module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ArticleList"
  }, [_c('ul', [_c('li', {
    class: {
      act: _vm.$route.path == '/AboutUs'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AboutUs'
        });
      }
    }
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/AdCooperation'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/AdCooperation'
        });
      }
    }
  }, [_vm._v("广告合作")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/EliteRecruitment'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/EliteRecruitment'
        });
      }
    }
  }, [_vm._v("精英招聘")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/Feedback'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/Feedback'
        });
      }
    }
  }, [_vm._v("意见反馈")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/TermsOfUse'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/TermsOfUse'
        });
      }
    }
  }, [_vm._v("使用条款")]), _vm._v(" "), _c('li', {
    class: {
      act: _vm.$route.path == '/ContactUs'
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          path: '/ContactUs'
        });
      }
    }
  }, [_vm._v("联系我们")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23dede2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_common/ArticleList.vue
// module id = 112
// module chunks = 15